import React from 'react';

import { BulletPoint, ComponentStyle, ProductCTA } from '../../../types/types';
import VerticalSplit from '../../shared/containers/VerticalSplit';

import { CtaTpContentContainer } from './CtaTpContentContainer';
import styled from '@emotion/styled';
import { CtaImage } from './CtaImage';

const CtaTpContainer = styled(VerticalSplit)({
  '&.F': {
    h2: {
      color: 'var(--color-primary)',
    },
  },
});

type Props = {
  title: string;
  points: BulletPoint[];
  description: string;
  paletteBackgroundColor: string;
  paletteTextColor: string;
  cta: ProductCTA;
  logo: string;
  style: ComponentStyle;
  image?: string;
  onCtaClick?: () => void;
  index?: number;
};

export const CtaTp: React.FC<Props> = ({ index, title, points, description, cta, logo, paletteBackgroundColor, paletteTextColor, style, image, onCtaClick }) => {
  const getContent = () => {
    switch (style) {
      case ComponentStyle.D:
        return (
          <>
            <CtaTpContentContainer style={style} title={title} description={description} cta={cta} onCtaClick={onCtaClick} paletteBackgroundColor={paletteBackgroundColor} paletteTextColor={paletteTextColor ? paletteTextColor : 'var(--color-white)'} />
            <CtaTpContentContainer style={style} logo={logo} points={points} />
          </>
        );
      case ComponentStyle.E:
        return (
          <>
            <CtaTpContentContainer style={style} title={title} description={description} logo={logo} points={points} cta={cta} paletteBackgroundColor={paletteBackgroundColor} paletteTextColor={paletteTextColor} onCtaClick={onCtaClick} />
            {image && <CtaImage image={image} className={style} />}
          </>
        );
      case ComponentStyle.F:
        return <CtaTpContentContainer style={style} title={title} cta={cta} onCtaClick={onCtaClick} points={points} />;
    }
  };
  return (
    <CtaTpContainer id={`mp-product-cta-${index}`} className={style} data-testid='mp-product-cta'>
      {getContent()}
    </CtaTpContainer>
  );
};
